// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"850":"4cbbc423","984":"3d9c1153"}[chunkId] + ".chunk.js";
};